import { useEffect, useState } from 'react';
import { DL_QUERY_STRINGS } from '../../../constants/dealerLocator.constants';
import { windowService } from '../../../utils/window.utils.js';

const useUserLocationState = (): [
  { lat: string; lng: string } | null,
  boolean,
  React.Dispatch<React.SetStateAction<{ lat: string; lng: string } | null>>
] => {
  const [userLatLng, setUserLatLng] = useState<{ lat: string; lng: string } | null>(null);
  const [valueIsFromQuery, setValueIsFromQuery] = useState<boolean>(false);
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const queryLat = getQuery(DL_QUERY_STRINGS.USER_LATITUDE);
  const queryLng = getQuery(DL_QUERY_STRINGS.USER_LONGITUDE);

  const updateLatLng = (value) => {
    setValueIsFromQuery(false);
    setUserLatLng(value);
  };

  useEffect(() => {
    if (!queryLat || !queryLng) {
      return;
    }
    setUserLatLng({ lat: queryLat ?? '', lng: queryLng ?? '' });
    setValueIsFromQuery(true);
  }, [queryLat, queryLng]);

  return [userLatLng, valueIsFromQuery, updateLatLng];
};

export default useUserLocationState;
